import type { ReactNode } from 'react'
import { CloudOff, RefreshCw } from 'lucide-react'

export function SkeletonBlock({ height = 80, radius = 16 }: { height?: number; radius?: number }) {
  return <div className="skeleton" style={{ height, borderRadius: radius }} aria-hidden />
}

export function ErrorState({
  message,
  onRetry,
}: {
  message: string
  onRetry?: () => void
}) {
  return (
    <div className="state state--error card">
      <CloudOff size={26} />
      <p>{message}</p>
      {onRetry && (
        <button className="state__btn" onClick={onRetry}>
          <RefreshCw size={15} /> Try again
        </button>
      )}
    </div>
  )
}

export function EmptyState({ icon, children }: { icon?: ReactNode; children: ReactNode }) {
  return (
    <div className="state state--empty">
      {icon}
      <p>{children}</p>
    </div>
  )
}
